// Piece 3 (GA elicitation workflow) — static, region-independent guided review
// questions rendered beside PrototypeViewer's existing per-screen annotate
// composer. VERIFY-c confirmed createPrototypeAnnotation always stores
// componentRegion: null (no layout/sections concept for a rendered
// prototype) — region is not available client- or server-side here, so this
// list is deliberately region-independent only, per the implementation
// prompt's own instruction not to add plumbing to fetch region.
//
// Answers ride the EXISTING annotation store (no new table, no migration):
// a guided answer is a normal annotation whose comment is prefixed with the
// question's label (VERIFY-a option (a) — annotations have no field to tag
// which question an answer belongs to). This convention is also the
// tagging format Piece 4 (refinement capture) will parse.

export interface GuidedQuestion {
  id: string;
  label: string;
}

export const GUIDED_REVIEW_QUESTIONS: GuidedQuestion[] = [
  { id: 'named', label: 'Is this screen named correctly for what it does?' },
  { id: 'missing', label: 'Is anything missing from this screen that the requirements imply?' },
  { id: 'roles', label: 'Does each role see the right things on this screen?' },
  { id: 'extra', label: "Is anything shown here that shouldn't be?" },
];

const GUIDED_PREFIX = '[Guided: ';

/** Build the stored annotation comment for a guided answer — prefixes the question's
 *  own label so a later reader (and Piece 4) can tell it apart from a free annotation. */
export function buildGuidedAnnotationComment(question: GuidedQuestion, answer: string): string {
  return `${GUIDED_PREFIX}${question.label}] ${answer}`;
}

/** Parse a stored annotation comment back into { label, answer } if it was written by
 *  buildGuidedAnnotationComment; null for a free (non-guided) annotation. Pure, never throws. */
export function parseGuidedAnnotation(comment: string): { label: string; answer: string } | null {
  if (!comment.startsWith(GUIDED_PREFIX)) return null;
  const closeIdx = comment.indexOf('] ', GUIDED_PREFIX.length);
  if (closeIdx === -1) return null;
  return {
    label: comment.slice(GUIDED_PREFIX.length, closeIdx),
    answer: comment.slice(closeIdx + 2),
  };
}
